module.exports = __webpack_public_path__ + "static/media/tab-select.349417e9.png";